export default __webpack_public_path__ + "static/web-booking-2df9ce7abb50e28fae78f8db70580d21.svg";